class BaseAnimation {
	constructor($scope, config) {
		this.$scope = $scope;
		this.config = config;
	}

	// Zet eventueel een beginstaat op het element. Mag de geometrie niet
	// verschuiven (geen transforms), anders klopt de viewport-detectie niet.
	init() {}

	// Voert de animatie daadwerkelijk uit.
	animate() {}

	// Draait terug wat init() heeft gezet, zodat het element weer zichtbaar
	// is. Wordt alleen aangeroepen voor nog niet geanimeerde elementen.
	destroy() {}
}

export default BaseAnimation;
